export default {
    //첫번째 인자 : state (무조건)
    //두번째 인자 : 받은 데이터 (= response.data)
    setPrepaidCardNo(state, prepaidCardNo) {
      state.prepaidCardNo = prepaidCardNo;
    },
    loadingOn(state) {
        state.loadingV2 += 1;
    },
    loadingOff(state) {
        state.loadingV2 -= 1;
    },
    loginAlertPopup(state, [loginModal, loginPath]) {
        if(loginPath) {
            if(loginPath === '/product/detail') {
                state.loginPath = '/home'
            } else {
                state.loginPath = loginPath;
            }
        }
        state.loginModal = loginModal;
    },

    //회원정보 Store에서 초기화
    resetMberInfo(state) {
        state.xScmToken = ''; //통신 토큰
        state.xRefToken = ''; //리프레시 토큰
        state.mberInfo = {}; // 회원정보
    },

    /**
     * 고객 정보를 세팅하는 함수
     * @param state
     * @param {Object} mberInfo
     */
    setMberInfo(state, mberInfo){
        state.xScmToken = mberInfo.xScmToken;
        state.xRefToken = mberInfo.xRefToken;
        state.mberInfo.mberNo = mberInfo.mberNo;
    },
    /**
     * 상품 정보를 세팅하는 함수
     * @param state
     * @param {Object} goodsInfo 상품 정보
     */
    setGoodsInfo(state, goodsInfo){
        state.goodsInfo = {...goodsInfo};
    },

    /**
     * 주문타입을 세팅하는 함수
     * @param state
     * @param {String} orderType 상품 정보
     */
    setOrderType(state, orderType){
        state.orderType = orderType;
    },


    /**
     * 본인인증 callback 함수
     * @param state
     * @param {Object} resData 본인인증 결과
    */
    certCallback(state, resData) {
      state.cert = resData;
      state.certCallback();
    },


  /**
   * 본인인증 callback 함수와 본인인증 정보를 초기화하는 함수
   * @param state
   */
    certInit(state) {
      state.certCallback = () => {
        return null;
      };
      state.cert = {};
    },


  /**
   * 이마티콘 회원 비밀번호 인증여부를 설정하는 함수
   * @param state
   */
    setIsMberPwdAuthenticated(state) {
      state.isMberPwdAuthenticated = true;
    },
    /**
     * 자동충전 계좌 등록 시 데이터 잃어버리지 않기 위한 설정
     */
    setAutoReloadCard(state, {autoReloadData, autoReloadCardInfo}){
        state.autoReloadData = autoReloadData; //자동충전 설정 정보
        state.autoReloadCardInfo = autoReloadCardInfo; //자동충전 선불카드 정보
    }
};
